// extracted by mini-css-extract-plugin
export default {"container":"Content_container__ncBYP","content":"Content_content__3ZaEO"};